import api from '.'

export const verifyLogin = (loginname: string, password: string) => {
  const param = { loginname, password }
  return api.post(`/api/authenticate`, param).then(response => {
    return response.data.token as string
  }) as Promise<string>
}